// extracted by mini-css-extract-plugin
module.exports = {"routing":"Routing_routing__1BeWg","hidden":"Routing_hidden__1XFHh"};